import { Body, Container, Heading, IconName } from '@vds/components';

import useTranslation from '@/hooks/providers/useTranslation';
import useBreakpoints from '@/hooks/utils/useBreakpoints';
import { getClientLOB, type LOB } from '@/utils/server/lob-utils';

import styles from './ErrorBoundaryContent.module.scss';

export interface RedirectButton {
    label: string;
    description: string;
    href: string;
    iconName: IconName;
}

type ErrorBoundaryLobConfig = {
    brand: 'pluto' | 'pplus';
    backgroundImage: string;
};

// Not using Regional configuration in case that is the reason for the error
const LOB_CONFIG: Record<LOB, ErrorBoundaryLobConfig> = {
    ptv: {
        brand: 'pluto',
        backgroundImage: '',
    },
    pplus: {
        brand: 'pplus',
        backgroundImage: '',
    },
};

export default function ErrorBoundaryContent() {
    const lob = getClientLOB();
    const { backgroundImage } = LOB_CONFIG[lob];
    const { t } = useTranslation();
    const title = t('error_boundary_title', null, 'Something went wrong');
    const subtitle = t('error_boundary_subtitle', null, 'Please try again');
    const { isMobilePortrait } = useBreakpoints();

    return (
        <div
            data-testid="error-boundary-layout"
            className={styles.mainLayout}
            style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}>
            <Container className={styles.container} flexDirection="column" gap="spacing-10">
                <Heading
                    size={isMobilePortrait ? 'small' : 'large'}
                    variant={isMobilePortrait ? 'display-01' : 'heading-02'}
                    align="center">
                    {title}
                </Heading>
                <Body
                    className={styles.subtitle}
                    align="center"
                    color="secondary"
                    size="medium"
                    variant="body-02"
                    weight="semibold">
                    {subtitle}
                </Body>
            </Container>
        </div>
    );
}
